// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-N6F6","right":"styles_right__3vHEM"};